import { render } from "./EditButton.vue?vue&type=template&id=0998a590"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__